/*{
    "id": 1,
    "meta_execucao_fisico_id": 1,
    "tipo": "receita",
    "orgao": "Secretaria de Educação",
    "etapa": 1,
    "fase": 1,
    "ano": 2023,
    "mes": 10,
    "total_meta": 100000.5,
    "created_at": "2023-10-01T12:00:00Z",
    "updated_at": "2023-10-01T12:00:00Z"
  }*/
import axios from "axios";

const API_URL = process.env.REACT_APP_API_KEY;

const postReceitasDespesas = async (
  token: string,
  meta_execucao_fisico_id: number,
  tipo: string,
  orgao: string,
  etapa: number,
  fase: number,
  ano: number,
  mes: number,
  total_meta: number
) => {
  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };
  const response = await axios.post(
    `${API_URL}/receitas-despesas`,
    {
      meta_execucao_fisico_id,
      tipo,
      orgao,
      etapa,
      fase,
      ano,
      mes,
      total_meta,
    },
    config
  );
  return response.data;
};
export default postReceitasDespesas;
